import { render, staticRenderFns } from "./damoxing_rec.vue?vue&type=template&id=638c5262&scoped=true"
import script from "./damoxing_rec.vue?vue&type=script&lang=js"
export * from "./damoxing_rec.vue?vue&type=script&lang=js"
import style0 from "./damoxing_rec.vue?vue&type=style&index=0&id=638c5262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c5262",
  null
  
)

export default component.exports